import { Outlet} from 'react-router-dom';

import { 
    Box,
    AppBar,
    Toolbar,
    Typography,
 } from '@mui/material';
import NavigationActions from '../navigationActions';
import { TrackingNavigationProvider } from '../trackingNavigation';

export default function Holder() {
    document.title = 'QA - Shiping';
    return(
        <TrackingNavigationProvider><Box>
            <AppBar 
                position="static"
            >
                <Toolbar
                    sx={{
                        gap: 2
                    }}
                >
                <NavigationActions />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    QA Shiping Report Station
                </Typography>
                
                </Toolbar>
            </AppBar>

            <Outlet/>
        </Box></TrackingNavigationProvider>
    );
}
